export default __webpack_public_path__ + "static/media/player.906aa606.png";